/**
 * A ação da seção sobe para a fileira do título, sem sair de dentro da seção.
 *
 * ── Por que um portal, e não subir o botão ────────────────────────────────
 *
 * "Convidar pessoa" abre um diálogo cujo estado vive em `SecaoPessoas`. Subir
 * o botão para `Administracao` levaria junto esse estado — e o mesmo para cada
 * seção que ganhar uma ação depois. A casca passaria a conhecer o miolo de
 * oito seções para desenhar uma fileira.
 *
 * O portal inverte: a casca oferece o LUGAR, e quem tem ação se pendura nele.
 * Quem não tem, não pendura nada, e a fileira fica só com o título — que é o
 * caso de seis das oito.
 *
 * ── Por que o alvo é estado, e não `ref` ──────────────────────────────────
 *
 * Um `ref` é `null` na primeira renderização, e o portal simplesmente não
 * apareceria até algo mais provocar uma segunda. Guardar o elemento em estado
 * pelo callback de `ref` provoca essa segunda renderização uma vez, quando o
 * nó existe.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const AlvoDasAcoes = createContext<HTMLElement | null>(null);

export function AcaoDaSecao({ children }: { children: ReactNode }): ReactNode {
  const alvo = useContext(AlvoDasAcoes);
  return alvo ? createPortal(children, alvo) : null;
}
